import type { LucideIcon } from 'lucide-react'
import { cn } from '@teach/ui'
import { getTypeChip } from '@/features/editor/constants/blockTypeColors'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export interface TileData {
  id: string
  label: string
  description: string
  icon: LucideIcon
}

interface Props {
  card: TileData
  disabled?: boolean
  onClick?: () => void
}

/** One block-type tile in the "add block" modal: colored icon chip + label + description. */
export const AddBlockTile = ({ card, disabled, onClick }: Props) => {
  const m = useMessages(messages)
  const Icon = card.icon
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'group flex flex-col items-center gap-3 rounded-2xl border-2 border-border bg-card p-4 text-center transition-all duration-200',
        disabled
          ? 'cursor-not-allowed opacity-50'
          : 'hover:border-foreground/20 hover:bg-foreground/5 hover:shadow-md',
      )}
    >
      <span
        className={cn(
          'flex h-14 w-14 items-center justify-center rounded-2xl transition-transform duration-200',
          getTypeChip(card.id),
          disabled ? '' : 'group-hover:scale-110',
        )}
      >
        <Icon className="h-6 w-6" />
      </span>
      <div>
        <p className="text-sm font-semibold text-foreground">{card.label}</p>
        <p className="mt-1 line-clamp-2 text-xs text-muted-foreground">
          {disabled ? m.comingSoon : card.description}
        </p>
      </div>
    </button>
  )
}
